export type ACLID = number;

export enum ROLES {
  First = 1,
  SuperAdmin = 1,
  Importer = 50,
  Last = 50
}

export interface Role {
  created_on: string;
  updated_on: string;
  id: ROLES;
  name: string;
  acl?: ACL[];
}

export interface ACL {
  created_on: string;
  updated_on: string;
  id: ACLID;
  activity: string;
  resource: string;
  roles?: Role[];
}
